import React from "react";
import { Link } from "react-router-dom";
import { usePermission } from "../hooks/usePermission";

export default function Home() {
  const { hasInventoryAccess, hasResultsAccess } = usePermission();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-3">
      <div className="max-w-4xl w-full">
        <div className="text-center mb-12">
          <img src="bonamuze-logo.png" className="logo-bonamuze"></img>
          <p className="text-2xl text-bonamuze-styled text-bonamuze-text">
            Beheersplatform van Dermatologie Muizen en Bona Derma
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {hasInventoryAccess ? (
            <Link
              to="/inventory-overview"
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="text-bonamuze mb-4">
                <svg
                  className="w-12 h-12 mx-auto"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                  />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-900 text-center mb-2">
                Voorraden
              </h2>
              <p className="text-gray-600 text-center text-sm">
                Beheer voorraden en producten
              </p>
            </Link>
          ) : (
            <div className="bg-white p-6 rounded-lg shadow-md opacity-60 cursor-not-allowed">
              <div className="text-bonamuze mb-4">
                <svg
                  className="w-12 h-12 mx-auto"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                  />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-900 text-center mb-2">
                Voorraden
              </h2>
              <p className="text-gray-600 text-center text-sm">
                Beheer voorraden en producten
              </p>
            </div>
          )}

          {hasResultsAccess ? (
            <Link
              to="/results/inkomstenfile"
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="text-bonamuze mb-4">
                <svg
                  className="w-12 h-12 mx-auto"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-900 text-center mb-2">
                Inkomsten
              </h2>
              <p className="text-gray-600 text-center text-sm">
                Beheer inkomsten en facturatie
              </p>
            </Link>
          ) : (
            <div className="bg-white p-6 rounded-lg shadow-md opacity-60 cursor-not-allowed">
              <div className="text-bonamuze mb-4">
                <svg
                  className="w-12 h-12 mx-auto"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-900 text-center mb-2">
                Inkomsten
              </h2>
              <p className="text-gray-600 text-center text-sm">
                Beheer inkomsten en facturatie
              </p>
            </div>
          )}

          <div className="bg-white p-6 rounded-lg shadow-md opacity-60 cursor-not-allowed">
            <div className="text-bonamuze mb-4">
              <svg
                className="w-12 h-12 mx-auto"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-900 text-center mb-2">
              Medewerkers
            </h2>
            <p className="text-gray-600 text-center text-sm">
              Beheer medewerkers
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
